import { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminLoader from './AdminLoader';
import { showError } from './adminAlerts';
import './adminShared.css';
import './AdminLogin.css';

function AdminLogin() {
  const { isAuthenticated, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    document.title = 'Admin | inmotion';
  }, []);

  if (isAuthenticated) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const result = await login(email, password);
    if (!result.success) {
      showError(result.error, 'Sign in failed');
    }

    setIsSubmitting(false);
  };

  return (
    <div className="admin-login">
      <div className="admin-login__panel">
        <div className="admin-login__brand">
          <img src="/inmotion logo.jpeg" alt="" className="admin-login__logo" />
          <span className="admin-login__brand-name">inmotion</span>
        </div>

        <div className="admin-login__panel-head">
          <h1 className="admin-login__title">Sign in</h1>
          <p className="admin-login__subtitle">
            Enter your staff credentials to continue.
          </p>
        </div>

        <form className="admin-login__form" onSubmit={handleSubmit}>
          <label className="admin-field">
            <span className="admin-field__label">Email</span>
            <input
              type="email"
              className="admin-field__input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              autoComplete="email"
              disabled={isSubmitting}
            />
          </label>
          <label className="admin-field">
            <span className="admin-field__label">Password</span>
            <input
              type="password"
              className="admin-field__input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              disabled={isSubmitting}
            />
          </label>
          <button
            type="submit"
            className="admin-btn admin-btn--primary admin-login__submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <AdminLoader label="" size="sm" inline />
                Signing in…
              </>
            ) : (
              'Sign in'
            )}
          </button>
        </form>

        <Link to="/" className="admin-login__back">
          ← Back to site
        </Link>
      </div>
    </div>
  );
}

export default AdminLogin;
